import {
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordRaw,
} from 'vue-router';

import { usePhysicalPrepaidCardSettingStore } from '@/store';
import { EAuthority } from '@/types';

/** 物理プリペイドカードの権限チェック */
const checkAuthorityBeforeEnter = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const store = usePhysicalPrepaidCardSettingStore();
  const menuDisplayFlag = store.physicalPrepaidCardSetting?.menuDisplayFlag;

  if (!menuDisplayFlag) {
    next({ name: 'NotFound' });
  } else {
    next();
  }
};

// 物理プリペイドカード関連
export const physicalPrepaidCardRoutes: Array<RouteRecordRaw> = [
  {
    name: 'PhysicalPrepaidCard',
    component: () => import('@/components/pages/physical-prepaid-card/index.vue'),
    path: '/physical-prepaid-card',
    meta: {
      title: '物理プリペイドカード',
      requiredAuthority: EAuthority.PHYSICAL_PREPAID_CARDS,
    },
    beforeEnter: checkAuthorityBeforeEnter,
  },
  {
    name: 'PhysicalPrepaidCardDetail',
    component: () => import('@/components/pages/physical-prepaid-card/detail/index.vue'),
    path: '/physical-prepaid-card/:cardNumber',
    meta: {
      title: '物理プリペイドカード詳細',
      requiredAuthority: EAuthority.PHYSICAL_PREPAID_CARDS,
    },
    beforeEnter: checkAuthorityBeforeEnter,
  },
];
